import React from 'react';
import { Box, Typography, Chip, Avatar } from '@mui/material';
import PropTypes from 'prop-types';

const CollaboratorItem = ({ collaborator, role }) => {
  const getInitials = (name) => {
    if (!name) return '?';
    return name
      .split(' ')
      .map((word) => word[0])
      .join('')
      .toUpperCase()
      .slice(0, 2);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        p: 1.5,
        borderRadius: 1,
        backgroundColor: 'action.hover',
        transition: 'background-color 0.2s',
        '&:hover': {
          backgroundColor: 'action.selected',
        },
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
        <Avatar
          sx={{
            width: 32,
            height: 32,
            backgroundColor: 'primary.main',
            color: 'primary.contrastText',
            fontSize: '0.875rem',
          }}
        >
          {getInitials(collaborator.name)}
        </Avatar>
        <Typography variant="body2" fontWeight="medium">
          {collaborator.name || 'Unknown'}
        </Typography>
      </Box>
      <Chip
        label={role}
        size="small"
        color={role === 'Co-author' ? 'secondary' : 'default'}
        variant="outlined"
        sx={{ textTransform: 'capitalize' }}
      />
    </Box>
  );
};

CollaboratorItem.propTypes = {
  collaborator: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  }).isRequired,
  role: PropTypes.oneOf(['Co-author', 'Editor']).isRequired,
};

export default CollaboratorItem;
